import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';

export class DimensionDto {
  @IsNumber()
  width!: number;

  @IsNumber()
  height!: number;
}

export class FileThumbnailDto {
  @IsString()
  folder!: string;

  @IsString()
  filename!: string;

  @IsNumber()
  size!: number;

  @IsOptional()
  @IsString()
  eTag?: string;

  @IsOptional()
  @IsString()
  url?: string;

  @ValidateNested()
  @Type(() => DimensionDto)
  dimension!: DimensionDto;
}

export type ThumbnailDimension = 'small' | 'medium';

export class FileThumbnailsDto {
  @ValidateNested()
  @Type(() => FileThumbnailDto)
  @IsOptional()
  small?: FileThumbnailDto;

  @ValidateNested()
  @Type(() => FileThumbnailDto)
  @IsOptional()
  medium?: FileThumbnailDto;
}
